<template>
    <div class="d-flex align-center">
        <v-combobox
            ref="functionCombobox"
            v-if="conversionType === 'function'"
            dense
            :value="value"
            :items="availableFunctions"
            :readonly="readonly"
            item-text="name"
            item-value="name"
            @input="handleInput"
            placeholder="Select function or type with parameters (e.g., concat|field1|field2| )"
            hint="You can select a function and add parameters using | separator"
            persistent-hint
            class="function-combobox"
            style="flex: 1;">
            <template v-slot:item="{ item }">
                <v-list-item-content>
                    <v-list-item-title class="function-item-name">
                        <v-icon small :color="item.native ? 'blue' : 'primary'" class="mr-1">
                            {{ item.native ? 'mdi-language-php' : 'mdi-function' }}
                        </v-icon>
                        {{ item.name }}
                        <v-chip
                            v-if="item.native"
                            x-small
                            color="blue"
                            text-color="white"
                            class="ml-2 px-2"
                            style="height: 16px; font-size: 10px;">
                            PHP Native
                        </v-chip>
                    </v-list-item-title>
                    <v-list-item-subtitle class="function-item-desc">
                        {{ item.shortDescription }}
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn
                        icon
                        x-small
                        color="primary"
                        @click.stop="handleHelpClick(item.name)"
                        title="View function documentation">
                        <v-icon small>mdi-help-circle-outline</v-icon>
                    </v-btn>
                </v-list-item-action>
            </template>
        </v-combobox>
        <v-btn
            v-if="conversionType === 'function' && extractFunctionName(value)"
            icon
            x-small
            color="primary"
            class="ml-1"
            @click="handleHelpClick(extractFunctionName(value))"
            title="View function documentation">
            <v-icon small>mdi-help-circle</v-icon>
        </v-btn>
        <v-text-field
            v-if="conversionType !== 'function'"
            dense
            :value="value"
            :readonly="readonly"
            @change="$emit('change', $event)">
        </v-text-field>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        },
        conversionType: {
            type: String,
            default: ''
        },
        availableFunctions: {
            type: Array,
            default: () => []
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            searchInput: null
        }
    },
    methods: {
        handleInput(value) {
            // Emit the string value
            this.$emit('change', value);
        },
        extractFunctionName(value) {
            if (!value) return '';
            
            // If value is an object (like {name: 'concat', ...}), return the name
            if (typeof value === 'object' && value.name) {
                return value.name;
            }
            
            // If value is a string, extract function name from syntax like "concat|param1|param2"
            if (typeof value === 'string') {
                const parts = value.split('|');
                return parts[0] || value;
            }
            
            return '';
        },
        handleHelpClick(functionName) {
            this.$emit('open-help', functionName);
        }
    }
}
</script>

<style scoped>
.function-item-name {
    font-family: 'Courier New', Monaco, monospace;
    font-size: 13px;
    font-weight: 700;
    color: #1565c0;
}

.function-item-desc {
    font-size: 12px;
    color: #666;
    margin-top: 2px;
    line-height: 1.3;
}

.function-combobox >>> input {
    cursor: text !important;
    user-select: text !important;
}
</style>
